const { isSimilar, getSimilarityScore } = require("../helpers/similarityHelper");
const { WASHING_STATUS, SIMILARITY_THRESHOLD } = require("../constants");

/**
 * Sipariş ve araç için uygunluk kontrolü yapar.
 * @param {Object} order - Sipariş detayları.
 * @param {Object} vehicle - Araç detayları.
 * @param {Array} products - Ürünler listesi.
 * @param {boolean} [isBulk=false] - Toplu taşıma kontrolü.
 * @param {boolean} [skipTheTonnage=false] - Taşıma kapasitesini es geçme kontrolü.
 * @returns {boolean} Araçın sipariş için uygun olup olmadığı bilgisi.
 */

function isWashStatus(customers, products, vehicle, order) {
  // Null/undefined check
  if (!order || !vehicle || !customers || !Array.isArray(customers)) {
    return {
      status: 0,
      score: 0
    };
  }

  const customer = customers.find(
    (c) => isSimilar(c.name, order.customer, SIMILARITY_THRESHOLD.EXACT_MATCH)
  );

  let scoreTypes = {
    status: 0,
    score: 0,
  };
  if ((customer?.requiredWashingStatus == WASHING_STATUS.YES) && vehicle?.isDirtyForDriver!=0) {
    // müşteri yıkamayı zorunlu tutmuş
    if(customer?.requiredWashingStatus) vehicle.customerRequiredWashing=true;
    scoreTypes.score = 1;
    scoreTypes.status = WASHING_STATUS.YES;
  } else {
    if (vehicle?.lastProduct || vehicle?.productId) {

      // ** Eğer canlı atama yapılacaksa aracın son yüküne değil mevcut yüküne göre yıkama kontrolü yapılır **
      const vehicleLastProduct=vehicle?.isSequentialTrue ? vehicle?.productId : vehicle.lastProduct;

      if ((vehicleLastProduct === (order?.productType || order?.productName)) || (vehicle?.isSequentialTrue ? false : vehicle?.isDirtyForDriver==0) ) {
        // ürün aynı ise yada Şöför teyidi aracın temiz olduğu ise yıkamaya gerek yok
        scoreTypes.score = 1;
        scoreTypes.status = WASHING_STATUS.NO;
      } else {

        const filteredProducts = products
        .map((pValue) => ({
          product: pValue,
          score: getSimilarityScore(
            pValue?.name,
            order?.productName ? order?.productName : order?.productType
          ),
        }))
        .filter((item) => item.score >= SIMILARITY_THRESHOLD.CLOSE_MATCH);
      const findProduct = filteredProducts.length
        ? filteredProducts.reduce((bestMatch, item) =>
            item.score > bestMatch.score ? item : bestMatch
          ).product
        : null; // Eğer uygun ürün yoksa `null` döndür

        // aracın en son taşıdığı yük ile mevcut ürünün birlikte yıkama yapmadan taşınabileceği ürünler kontrol edilir
        if (
          findProduct?.movableProducs?.some(
            (r) => isSimilar(r.name, vehicleLastProduct, SIMILARITY_THRESHOLD.CLOSE_MATCH)
          )
        ) {
          // aracı yıkamaya gerek yok
          scoreTypes.score = 0.5;
          scoreTypes.status = WASHING_STATUS.NO;
        } else {
          scoreTypes.score = 1;
          scoreTypes.status = WASHING_STATUS.YES;
        }
      }
    } else {
      scoreTypes.score = 1;
      scoreTypes.status = vehicle.isDirtyForDriver == 0 ? WASHING_STATUS.NO : WASHING_STATUS.DRIVER_ACTION;
      // son ürün yok ise ve sürücü temiz teyidi yok ise sürücüye sormalısın
    }
  }
  return scoreTypes;
}


module.exports={
    isWashStatus
}
